/**
 * Video Background Wrapper - Reposition to cover Section and pause when out of view
 */
(function () {
  'use strict';

  function repositionVideoBackgrounds() {
    const videoBackgrounds = document.querySelectorAll('.x-bg');

    videoBackgrounds.forEach((bgElement) => {
      // Skip if already repositioned
      if (bgElement.dataset.repositioned === 'true') {
        return;
      }

      // Find the parent section
      let section = bgElement.closest('.vc_section');

      if (!section) {
        // If no section found, try to find the closest parent that might be a section
        let parent = bgElement.parentElement;
        while (parent && !parent.classList.contains('vc_section')) {
          parent = parent.parentElement;
          if (!parent || parent.tagName === 'BODY') {
            return; // No section found
          }
        }
        section = parent;
      }

      if (section) {
        // Move the video background to be the first child of the section
        // This ensures it covers the entire section
        section.insertBefore(bgElement, section.firstChild);
        bgElement.dataset.repositioned = 'true';
        bgElement.classList.add('x-bg-repositioned');
      }
    });
  }

  function initVideoBackgroundWrapper() {
    // First, reposition all video backgrounds to cover their sections
    repositionVideoBackgrounds();

    const videoElements = document.querySelectorAll(
      '.x-bg .x-video[data-x-video-options]'
    );

    if (videoElements.length === 0) {
      return;
    }

    // Check if Intersection Observer is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: videos will continue playing
      console.warn(
        'IntersectionObserver not supported. Videos will not pause when out of view.'
      );
      return;
    }

    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.1, // Trigger when 10% of video is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          // Video is in viewport - play it
          if (video.paused) {
            video.play().catch((error) => {
              // Autoplay may be blocked by browser
              console.warn('Video autoplay blocked:', error);
            });
          }
        } else {
          // Video is out of viewport - pause it
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, observerOptions);

    // Observe all video elements
    videoElements.forEach((video) => {
      // Ensure video is initially playing if in viewport
      const rect = video.getBoundingClientRect();
      const isInViewport =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      if (!isInViewport) {
        video.pause();
      }

      observer.observe(video);
    });
  }

  // Initialize when DOM is ready
  if (
    document.readyState === 'loading' ||
    document.readyState === 'interactive'
  ) {
    document.addEventListener('DOMContentLoaded', function () {
      initVideoBackgroundWrapper();
      // Also reposition after a short delay to handle dynamic content
      setTimeout(repositionVideoBackgrounds, 100);
    });
  } else {
    // DOM is already ready
    initVideoBackgroundWrapper();
    setTimeout(repositionVideoBackgrounds, 100);
  }

  // Re-initialize for dynamically loaded content (e.g., AJAX)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('vc_reload', function () {
      // Reset repositioned flag on reload
      document.querySelectorAll('.x-bg').forEach((el) => {
        el.dataset.repositioned = 'false';
      });
      initVideoBackgroundWrapper();
      setTimeout(repositionVideoBackgrounds, 100);
    });
  }

  // Also run on window load to catch any late-loading content
  window.addEventListener('load', function () {
    setTimeout(repositionVideoBackgrounds, 100);
  });
})();

